import {
	BehaviorSubject,
	Subscription
}	from 'rxjs';
import { BrandService }			from './brand.service';
import {
  Inject,
  Injectable
}														from '@angular/core';
import { UtilityService }		from './utility.service';

interface TokenCallback { (token: string): void }

@Injectable()
export class TokenService {
	disposables:	Subscription[] = [];
	token:				BehaviorSubject<string> = new BehaviorSubject('a');

	constructor(
    private brandService:   BrandService,
    private utilityService: UtilityService
  ) {
		this.getNewToken();

    console.log('Token service created');
	}

	getNewToken() {
    if (this.token.value.length > 0) {
      console.log('New token requested');

      this.token.next('');

      this.utilityService.httpPost(
        this.brandService.baseUrl + 'token',
        { brand_name: this.brandService.brandName },
        data => {
          if (typeof data.error === 'string') {
            console.log(data.error);
          } else {
            this.token.next(data.token);

						for (var i = 0, len = this.disposables.length; i < len; i++) {
							this.disposables[i].unsubscribe();
						}
          }
        },
        this
      )
    }
  }

	getToken(callback: TokenCallback) {
		let currentToken = this.token.value;
		
		if (currentToken.length === 0) {
			this.disposables.push(this.token.subscribe(newToken => {
				if (newToken.length > 0) {
					callback(newToken)
				}
			}));
		} else {
			callback(currentToken);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/token.service.ts